import { AnalyticsBrowser } from '@segment/analytics-next';

import { SEGMENT_KEY } from '../shared/Constants';

export const analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_KEY });
